module.exports = __webpack_public_path__ + "img/process-recommendation-list.77b86028.png";